import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme, ColorTheme } from '../context/ThemeContext';
import ElephantLogo from './ElephantLogo';

const themeOptions: { value: ColorTheme; label: string; emoji: string }[] = [
  { value: 'light', label: 'Lys', emoji: '☀️' },
  { value: 'dark', label: 'Mørk', emoji: '🌙' },
  { value: 'forest', label: 'Skov', emoji: '🌿' },
  { value: 'ocean', label: 'Hav', emoji: '🌊' },
  { value: 'retro', label: 'Retro', emoji: '📺' },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" className="brand-link">
          <ElephantLogo size={36} />
          <span className="brand-name">Krunk</span>
        </Link>
      </div>

      <div className="navbar-links">
        {user ? (
          <>
            <Link to="/memes" className="nav-link">🎭 Memes</Link>
            <Link to="/quiz" className="nav-link">🧠 Quiz</Link>
            <Link to="/forum" className="nav-link">💬 Forum</Link>
            <Link to="/parties" className="nav-link">🎉 Fester</Link>
          </>
        ) : null}
      </div>

      <div className="navbar-right">
        <select
          className="theme-select"
          value={theme}
          onChange={(e) => setTheme(e.target.value as ColorTheme)}
          title="Skift tema"
        >
          {themeOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.emoji} {opt.label}
            </option>
          ))}
        </select>

        {user ? (
          <div className="navbar-user">
            <span className="username">👤 {user}</span>
            <button onClick={handleLogout} className="btn btn-outline">
              Log ud
            </button>
          </div>
        ) : (
          <div className="navbar-auth">
            <Link to="/login" className="btn btn-outline">Log ind</Link>
            <Link to="/signup" className="btn btn-primary">Opret konto</Link>
          </div>
        )}
      </div>
    </nav>
  );
}
